import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { SecondaryButton } from '@components/Buttons/SecondaryButton';
import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowActions } from '@components/Modal/ModalWindowActions';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { IModalWindow } from '@hooks/useModalWindow';
import { DialogContentText } from '@material-ui/core';
import React from 'react';


export type ClienteDebitoMOdalProps = {
    modal: IModalWindow
    onContinue: VoidFunction
}

export function ClienteDebitoModal ({modal, onContinue}: ClienteDebitoMOdalProps) {
    return (
        <ModalWindow
            disabled={false}
            modal={modal}
        >
            <ModalWindowTitle 
                title="Débitos Encontrados"
                hasCloseButton={false}
            />

            <ModalWindowContent>
                <DialogContentText>Este cliente possui débitos. Tem certeza que deseja continuar?</DialogContentText>
            </ModalWindowContent>

            <ModalWindowActions>
                <PrimaryButton onClick={onContinue}>Continuar</PrimaryButton>
                <SecondaryButton  onClick={modal.close} variant="contained">Rejeitar</SecondaryButton>
            </ModalWindowActions>
        </ModalWindow>
    )
}